import { ref } from 'vue';
import { 
  getDocs, 
  query, 
  limit, 
  startAfter, 
  getCountFromServer 
} from 'firebase/firestore';

import { getFilteredPetsQuery } from '@/services/petService.js';
import { usePetStore } from '@/stores/petStore'; // En üste import ekleyin




const PAGE_LIMIT = 100;

export const useGetPetAds = () => {
  const petStore = usePetStore(); // Store'u composable içinde başlat
  // State tanımlamaları
  const petAds = ref([]);
  const error = ref(null);
  const loading = ref(false);
  const hasMore = ref(true);
  const lastVisible = ref(null);
  const totalCount = ref(0);

  // Temel sorgu oluşturma fonksiyonu petService'e taşındı

  // State'i sıfırlama
  const resetState = () => {
    petAds.value = [];
    lastVisible.value = null;
    hasMore.value = true;
    error.value = null;
  };

  // Ana fetch fonksiyonu
  const fetchPetAds = async (isLoadMore = false, filters = {}) => {
    if (loading.value) return;
    try {
      loading.value = true;
      

      // Yeni sorgu başlatılıyorsa state'i sıfırla
      if (!isLoadMore) {
        resetState();
        const baseQuery = getFilteredPetsQuery(filters);
        const countSnapshot = await getCountFromServer(baseQuery);
        totalCount.value = countSnapshot.data().count;
      }

      // Eğer daha fazla ilan yoksa ve yükleme isteği varsa çık
      if (!hasMore.value && isLoadMore) {
        return;
      }

      // Sorgu oluştur
      let finalQuery = isLoadMore && lastVisible.value
      ? query(getFilteredPetsQuery(filters), startAfter(lastVisible.value), limit(PAGE_LIMIT))
      : query(getFilteredPetsQuery(filters), limit(PAGE_LIMIT));


      // Sayfalama için sorguyu güncelle
      if (isLoadMore && lastVisible.value) {
        finalQuery = query(
          finalQuery,
          startAfter(lastVisible.value),
          limit(PAGE_LIMIT)
        );
      } else {
        finalQuery = query(finalQuery, limit(PAGE_LIMIT));
      }

      // Verileri getir
      const querySnapshot = await getDocs(finalQuery);
      
      // Eğer yeni veri gelmezse hasMore'u false yap
      if (querySnapshot.empty) {
        hasMore.value = false;
        return;
      }

      const newAds = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Sonuçları state'e kaydet
      if (isLoadMore) {
        petAds.value = [...petAds.value, ...newAds];
      } else {
        petAds.value = newAds;
      }

      // Son görünen dokümanı ve daha fazla ilan olup olmadığını güncelle
      lastVisible.value = querySnapshot.docs[querySnapshot.docs.length - 1];
      hasMore.value = querySnapshot.docs.length === PAGE_LIMIT;

    } catch (err) {
      error.value = `İlanlar yüklenirken bir hata oluştu: ${err.message}`;
      console.error('Hata detayı:', err);
    } finally {
      loading.value = false;
      petStore.setPetAds(petAds.value);
      //console.log('Pet Store güncellendi:', petAds.value);
      
    }
  };

  return {
    petAds,
    error,
    loading,
    totalCount,
    fetchPetAds,
    hasMore,
    resetState
  };
};